<script setup lang="ts">
  import { Primitive, type PrimitiveProps } from 'reka-ui'
  import { computed, inject, type HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'
  import {
    type ButtonVariants,
    buttonSizeKey,
    buttonVariants
  } from './button-variants'

  export interface ButtonProps extends PrimitiveProps {
    variant?: ButtonVariants['variant']
    size?: ButtonVariants['size']
    class?: HTMLAttributes['class']
    disabled?: boolean
    dataTestid?: string
  }

  const props = withDefaults(defineProps<ButtonProps>(), {
    as: 'button'
  })

  /** Size supplied by an ancestor (e.g. `ModalFooter`); an explicit prop wins. */
  const injectedSize = inject(buttonSizeKey, undefined)
  const resolvedSize = computed(() => props.size ?? injectedSize?.value ?? 'sm')
</script>

<template>
  <Primitive
    data-slot="button"
    :as="as"
    :as-child="asChild"
    :class="cn(buttonVariants({ variant, size: resolvedSize }), props.class)"
    :disabled
    :data-testid="props.dataTestid"
  >
    <slot />
  </Primitive>
</template>
